/**
 * Promise.withResolvers is neat and it's available in browsers since mid-2023,
 * but not yet in our CI
 */
export function withResolvers<T>() {
  // eslint-disable-next-line dot-notation
  if (Promise['withResolvers']) return Promise.withResolvers<T>();

  let capturedResolve: (value: T) => void;
  let capturedReject: (reason: any) => void;
  const promise = new Promise<T>((resolve, reject) => {
    capturedResolve = resolve;
    capturedReject = reject;
  });
  // @ts-ignore
  return { resolve: capturedResolve, reject: capturedReject, promise };
}
